import { SupabaseClient } from "@supabase/supabase-js";
import { RawEmailData, EmailSummaryForHook } from "./types";

export const mapRawEmailToEmailSummary = (email: RawEmailData): EmailSummaryForHook => {
  let parsedAssignedTo = null;
  if (email.assignedto) {
    if (typeof email.assignedto === 'object' && 
        email.assignedto !== null && 
        'type' in email.assignedto && 
        'id' in email.assignedto && 
        'name' in email.assignedto) {
      parsedAssignedTo = {
        type: email.assignedto.type as "candidate" | "client",
        id: email.assignedto.id as string,
        name: email.assignedto.name as string
      };
    }
  }
  
  let parsedExtractedEntities: Record<string, any> | null = null;
  if (email.extracted_entities) {
    if (typeof email.extracted_entities === 'string') {
      try {
        parsedExtractedEntities = JSON.parse(email.extracted_entities);
      } catch (e) {
        console.error("Failed to parse extracted_entities:", e);
        // Keep parsedExtractedEntities as null
      }
    } else if (typeof email.extracted_entities === 'object' && email.extracted_entities !== null) {
      // Assuming it's already a Record<string, any> or compatible
      parsedExtractedEntities = email.extracted_entities as Record<string, any>;
    } else {
      // Handle cases where it might be an array or other JsonValue subtype if necessary
      // For now, if it's not string or object, treat as unparsable to Record<string, any>
      console.warn("extracted_entities is not a string or a parseable object:", email.extracted_entities);
    }
  }

  return {
    id: email.id,
    subject: email.subject,
    sender: email.sender,
    receivedAt: new Date(email.received_at),
    summary: email.summary,
    assignedTo: parsedAssignedTo,
    link: email.link,
    nextSteps: email.next_steps || [],
    is_archived: email.is_archived,
    is_flagged: email.is_flagged,
    updated_at: email.updated_at ? new Date(email.updated_at) : undefined,
    categories: email.categories || [],
    tags: email.tags || [],
    processing_status: email.processing_status || 'unknown',
    provider_message_id: email.provider_message_id,
    provider_thread_id: email.provider_thread_id,
    extractedEntities: parsedExtractedEntities,
    sentiment: email.sentiment || null,
    priorityScore: email.ai_priority_score !== undefined && email.ai_priority_score !== null ? email.ai_priority_score : null,
  };
};

export const fetchProcessedEmailsFn = async (supabase: SupabaseClient): Promise<EmailSummaryForHook[]> => {
  const { data: emails, error } = await supabase
    .from('processed_emails')
    .select('*')
    .eq('is_archived', false)
    .order('received_at', { ascending: false });

  if (error) throw error;

  return emails.map(mapRawEmailToEmailSummary);
};
